
export enum MediaCapabilitiesCodec {
    AVC = 'avc1.4D401E,mp4a.40.2',
    HEVC = 'hev1.1.2.L93.B0',
    VP8 = 'vp8, opus, vorbis',
    VP9 = 'vp9, opus, vorbis',
    AV1 = 'av1.experimental.e87fb2378f01103d5d6e477a4ef6892dc714e614'
}

